import { Box } from "@chakra-ui/react";
import { HStack, responsive, VStack } from "goi_common";
import Slider from "react-slick";

import dynamic from "next/dynamic";

const NoSSRLimitItem = dynamic(() => import("./LimitItem"), { ssr: false });

export default function LimitSection() {
  const initialSlide = 0;

  const randomCompanys = [
    {
      companyName: "노**아**코리아",
      name: "박**",
      requestService: "상조용품, 화환",
      scale: "100명~500명",
    },
    {
      companyName: "A**le Kor**",
      name: "박**",
      requestService: "상조용품, 상조서비스",
      scale: "500명~1000명",
    },
    {
      companyName: "시**",
      name: "이**",
      requestService: "상조서비스",
      scale: "100명 이하",
    },
    {
      companyName: "씨**엠 주식회사",
      name: "신**",
      requestService: "상조용품",
      scale: "100명~500명",
    },
    {
      companyName: "대*중공업",
      name: "박**",
      requestService: "상조용품, 상조서비스",
      scale: "500명~1000명",
    },
    {
      companyName: "동북아*****",
      name: "류**",
      requestService: "상조서비스",
      scale: "100명 이하",
    },
    {
      companyName: "한국**경제***",
      name: "강**",
      requestService: "상조용품, 기타 제휴",
      scale: "100명~500명",
    },
    {
      companyName: "로우****티브",
      name: "최**",
      requestService: "상조용품, 기타 제휴",
      scale: "100명 이하",
    },
  ];

  return (
    <VStack alignItems="center">
      <Box
        textAlign="center"
        className="white subtitle_18_b md_head_32_b"
        margin="40px 0"
      >
        신청현황
      </Box>

      <HStack
        className="white subtitle_18_b"
        css={responsive({
          width: { base: "360px", md: "800px" },
          marginBottom: { base: "20px", md: "20px" },
        })}
      >
        <Box width="25%" textAlign="center">
          회사
        </Box>
        <Box width="25%" textAlign="center">
          신청인
        </Box>
        <Box width="25%" textAlign="center">
          요청서비스
        </Box>
        <Box width="25%" textAlign="center">
          규모
        </Box>
      </HStack>

      <VStack alignItems="center">
        <VStack
          position="relative"
          overflow="hidden"
          height="300px"
          css={responsive({
            flexShrink: 1,
            width: { base: "360px", md: "800px" },
          })}
        >
          <Slider
            initialSlide={initialSlide}
            dots={false}
            infinite={true}
            arrows={false}
            slidesToShow={3}
            slidesToScroll={1}
            vertical={true}
            verticalSwiping={true}
            swipeToSlide={true}
            autoplay={true}
            speed={300}
          >
            {randomCompanys.map((i, index) => (
              <NoSSRLimitItem key={"slide" + index} {...i} />
            ))}
          </Slider>
        </VStack>
      </VStack>
    </VStack>
  );
}
